import styled from "styled-components";

export const GeneralContainerInsight = styled.div`
  display: flex;
  width: 100vw;
  background-color: ${({ theme }) => theme.primaryBackgroundLight};
`;

export const ContentFormInsight = styled.div`
  padding: 3em 7em 0em 10em;
  margin: 1em 1em 0em 4em;
  text-align: center;
  width: 60vw;
  height: 100vh;
  background-color: ${({ theme }) => theme.secondaryGrayLightNine};
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 0.3em;
  }
  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.neutral.gray[1000]};
    border-radius: 3px;
    border: 1px solid #c7b9c475;
  }
  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px #fdfdfd73;
    border-radius: 10px;
  }
`;

export const ContentCommentsInsight = styled.div`
  background-color: ${({ theme }) => theme.primaryBackgroundLight};
  width: 36vw;
  height: fit-content;
`;

export const ContentInsight = styled.div`
  background-color: ${({ theme }) => theme.primaryBackgroundLight};
  border: 1px solid ${({ theme }) => theme.secondaryGrayLightThree};
  margin: 1em 6vw 1em 1em;
  padding: 1em;
`;

export const ContentAnswerInsight = styled.div`
  background-color: ${({ theme }) => theme.neutral.white};
  border-radius: 4px;
  padding: 2em;
  margin: 2em 0em;
  p:nth-child(1) {
    font-size: 16px;
    font-weight: 600;
    text-align: initial;
    margin: 9px 0;
  }
  p:nth-child(2) {
    background: ${({ theme }) => theme.neutral.gray[400]};
    border-radius: 3px;
    padding: 0.3em 1.5em;
    text-align: initial;
    display: flex;
    align-items: center;
    min-height: 40px;
  }
`;

export const RowForm = styled.div`
  display: flex;
  justify-content: space-around;
  flex-direction: row;
  width: fit-content;
  margin: 1em 0;
`;

export const ColContent = styled.div`
  display: flex;
  flex-direction: column;
  #comment-description {
    font-size: 12px;
    background-color: #d9d9d980;
    width: 15vw;
    height: 51px;
    border-radius: 10px;
    padding: 0px 9px;
  }
`;

export const ContentProfile = styled.div`
  width: 3em;
  height: 3em;
`;

export const ImgProfile = styled.img`
  width: 2em;
  height: 2em;
  border-radius: 99px;
`;

export const ContentUpdateButton = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
`;

export const ButtonDone = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 114px;
  height: 36px;
    background: ${({ theme }) => theme.button.primary};
  border-radius: 4px;
  border: none;
  color: white;
  font-size: 14px;
  &:hover {
    box-shadow: ${({ theme }) => theme.button.buttonHoverShadow};
    transform: translateY(-1px);
    cursor: pointer;
  }
  a {
    color: ${({ theme }) => theme.neutral.gray[200]};
    text-decoration: none;
    background-color: transparent;
  }
  &:disabled {
    opacity: 0.5;
  }
`;
